<template>
  <div
    class="pin-item"
    :class="states"
  >
    <slot name="default" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue-demi';

export default defineComponent({
  name: 'PinItem',
  props: {
    isPinned: Boolean,
  },
  computed: {
    states(): string[] {
      return this.isPinned ? ['attached'] : ['detached', 'centered'];
    },
  },
});
</script>

<style lang="scss" scoped>
.pin-item {
  &.attached {
    position: static;
  }

  &.detached {
    position: fixed;
  }

  &.centered {
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
</style>
